export default __webpack_public_path__ + "static/track_and_analyze_governance_actions-6c0d1c79aef8c4d951e1dcdea78ba768.svg";